import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataTable from '../../../sharedModules/dataTable';
import PageHeader from '../../../sharedModules/layout/PageHeader';
import axios from '../../../sharedModules/utils/axios.utils';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    padding: 0,
  },
  box: {
    width: '100%',
  },
  content: {
    marginLeft: '0px',
    padding: '80px 30px',
  },
}));

const plumberDetailsColumns = [
  {
    name: 'Name',
    selector: (row: any) => row.full_name,
    sortable: true,
    grow: 2,
  },
  {
    name: 'Employee ID',
    selector: (row: any) => row.employee_id || 'N/A',
    sortable: true,
  },
  {
    name: 'Certification Number',
    selector: (row: any) => row.certification_number || 'Not Set',
    sortable: true,
  },
  {
    name: 'Cert. Expiration',
    selector: (row: any) => row.certification_expiration || 'Not Set',
    sortable: true,
  },
  {
    name: 'Device Manufacturer',
    selector: (row: any) => row.device_manufacturer || 'Not Set',
    sortable: true,
    grow: 2,
  },
  {
    name: 'Device Model',
    selector: (row: any) => row.device_model || 'Not Set',
    sortable: true,
  },
  {
    name: 'Device Serial #',
    selector: (row: any) => row.device_serial_number || 'Not Set',
    sortable: true,
  },
  {
    name: 'Calibration Date',
    selector: (row: any) => row.calibration_date || 'Not Set',
    sortable: true,
  },
  {
    name: 'Calibration Expiration Date',
    selector: (row: any) => row.calibration_expiration_date || 'Not Set',
    sortable: true,
  },
];

const BackflowPlumberDetailsPage: React.FC = () => {
  const classes = useStyles();
  const [plumberData, setPlumberData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlumberDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axios.get<string, any>('/backflows/backflow_plumber_details');
        setPlumberData(response?.data?.result || []);
      } catch (error) {
        console.error('Error fetching plumber details:', error);
        setError('Failed to load plumber details. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchPlumberDetails();
  }, []);

  if (loading) {
    return (
      <Box className={classes.root}>
        <Box className={classes.box}>
          <Box className={classes.content}>
            <PageHeader mainTitle="Backflow Testing" subTitle="Plumber Configuration" />
            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>Loading plumber details...</div>
          </Box>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box className={classes.root}>
        <Box className={classes.box}>
          <Box className={classes.content}>
            <PageHeader mainTitle="Backflow Testing" subTitle="Plumber Configuration" />
            <div style={{ color: 'red', textAlign: 'center', padding: '50px' }}>{error}</div>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Grid container justifyContent="space-between">
          <Grid item style={{ marginBottom: 3 }}>
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              Backflow Testing
            </Typography>
            <NavigateNextIcon
              fontSize="small"
              style={{
                color: '#3d5a80 !important',
                fontWeight: 700,
                fontSize: '20px !important',
                margin: '-4px 4px',
              }}
            />
            <Typography style={{ display: 'inline-block', fontSize: '20px' }} variant="h3">
              Plumber Configuration
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Card>
          <CardContent>
            <Box sx={{ mt: 3 }}>
              <DataTable
                title=""
                columns={plumberDetailsColumns}
                data={plumberData}
                pagination
                paginationPerPage={25}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                pointerOnHover
                responsive
                dense
                noHeader
              />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BackflowPlumberDetailsPage;
